export const CHATWOOT_ERROR = 'aicc:error';
export const CHATWOOT_ON_MESSAGE = 'aicc:on-message';
export const CHATWOOT_ON_START_CONVERSATION = 'aicc:on-start-conversation';
export const CHATWOOT_READY = 'aicc:ready';
